import { Truck, Shield, Phone, CreditCard } from "lucide-react";

export const TrustBadges = ({ theme, storeAppearance }) => {
  if (storeAppearance?.trust_badges_enabled === false) return null;

  const badges = [
    {
      icon: Truck,
      text: storeAppearance.trust_free_shipping
    },
    {
      icon: Shield,
      text: storeAppearance.trust_quality_guarantee
    },
    {
      icon: Phone,
      text: storeAppearance.trust_customer_support
    },
    {
      icon: CreditCard,
      text: storeAppearance.trust_secure_payment
    },
  ];

  return (
    <section className="py-8 border-b" style={{ backgroundColor: theme.primary_color }}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {badges.map((badge, index) => (
            <div key={index} className="flex items-center justify-center gap-3 text-white py-2">
              <badge.icon className="w-6 h-6 flex-shrink-0" style={{ color: theme.accent_color }} />
              <span className="text-sm font-medium">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
